<template>
  <v-dialog v-model="valueLocal" :max-width="$i18n.locale === 'ru' ? 400 : 420">
    <ng-sheet class="payment-success-dialog">
      <div class="text-center">
        <v-icon x-large color="primary">mdi-basket-check</v-icon>
        <h2 class="mt-3">{{ $t('order.thanksForOrder.title') }}</h2>
      </div>
      <div>
        <p
          v-html="
            $t('order.thanksForOrder.weStarted', {
              email: email ? `<a href='mailto:${email}'>${email}</a>` : $t('order.thanksForOrder.yourEmail'),
            })
          "
        ></p>
        <p v-html="$t('order.thanksForOrder.resultWillBeSent')"></p>
        <p v-html="$t('order.thanksForOrder.executionTime', [productionTimeString])"></p>
        <p v-html="$t('order.thanksForOrder.letUsKnow')"></p>
      </div>
      <ng-button icon icon-name="mdi-close" class="payment-success-dialog__close" @click="hide" text />
    </ng-sheet>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { getProductionTimeString } from '@/utils/productUtils';

export default {
  name: 'PaymentSuccessDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    productionTime: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('order', ['email']),
    valueLocal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    productionTimeString() {
      return getProductionTimeString(this.productionTime, { parentCase: true });
    },
  },
  methods: {
    hide() {
      this.valueLocal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-success-dialog {
  position: relative;

  &__close {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
}
</style>
